// extracted by mini-css-extract-plugin
export var activeTab = "OurPeople-module--activeTab--48f0b";
export var courseInformation = "OurPeople-module--courseInformation--7a6e6";
export var courseInformationContentWrapper = "OurPeople-module--courseInformationContentWrapper--b75d4";
export var courseInformationSummaryTitle = "OurPeople-module--courseInformationSummaryTitle--89e92";
export var courseInformationToc = "OurPeople-module--courseInformationToc--44ba5";
export var dataTab = "OurPeople-module--dataTab--8b107";
export var intro = "OurPeople-module--intro--1a6e2";
export var introWrapper = "OurPeople-module--introWrapper--921e5";
export var subTabcontent = "OurPeople-module--subTabcontent--34462";
export var tabList = "OurPeople-module--tabList--f4c27";
export var title = "OurPeople-module--title--c37bf";
export var wrapper = "OurPeople-module--wrapper--22c22";